(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    // Set initial header height CSS variable
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener(
      'change',
      this.setHeaderHeight.bind(this)
    );

    // Always-sticky modes
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    // Scroll-based show/hide
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    // Observe initial header bounds
    this.createObserver();
   
    // === Mega-menu toggle integration ===
    this.megaMenus = this.header.querySelectorAll('.mega-menu');
    this.megaMenus.forEach((menu) => {
      menu.addEventListener('toggle', this.handleMegaMenuToggle.bind(this));
    });
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    // Clean up mega-menu listeners
    this.megaMenus.forEach((menu) => {
      menu.removeEventListener('toggle', this.handleMegaMenuToggle.bind(this));
    });
  }

  // Adjust header-height CSS variable
  setHeaderHeight() {
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
  }

  // IntersectionObserver to capture header bounds
  createObserver() {
    const observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  // Main scroll handler
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  
    const isMenuOpen = this.header.classList.contains('menu-open');
  
    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide || isMenuOpen) return; // 👈 Prevent hide if menu is open
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        if (!isMenuOpen) requestAnimationFrame(this.hide.bind(this)); // 👈 Also skip hide if menu open
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      if (!isMenuOpen) requestAnimationFrame(this.reset.bind(this)); // 👈 Only reset if menu not open
    }
  
    this.currentScrollTop = scrollTop;
  }


  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );
    this.closeMenuDisclosure();
    this.closeSearchModal();
    this.closeMegaMenus(); // 👈 New addition
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }
  closeMegaMenus() {
    const openMenus = this.header.querySelectorAll('.mega-menu[open]');
    this.header.classList.remove('menu-open');
    openMenus.forEach(menu => {
      menu.removeAttribute('open');
    });
  }
  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }

  // Handle mega-menu open/close
  handleMegaMenuToggle(event) {
    const menu = event.currentTarget;
    const nbMark = document.querySelector('.header .nb-mark');
  
    if (menu.hasAttribute('open')) {
      this.header.classList.add('shopify-section-header-sticky', 'menu-open');
      //nbMark.classList.add('hide-me');
    } else {
      //nbMark.classList.remove('hide-me');
      this.header.classList.remove('menu-open');
  
      // ✅ Only remove sticky class if user is at the top of the page
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('shopify-section-header-sticky');
      }
    }
  }

}

customElements.define('sticky-header', StickyHeader);
  
   document.addEventListener('DOMContentLoaded', function () {
    const drawer = document.getElementById('menu-drawer');
    const detailsEl = document.getElementById('Details-menu-drawer-container');

    detailsEl.addEventListener('toggle', function () {
      const items = drawer.querySelectorAll('.menu-drawer__menu-item');

      if (detailsEl.open) {
        drawer.classList.add('opening');

        items.forEach((item, i) => {
          item.style.transitionDelay = `${i * 90}ms`;
        });

      } else {
        drawer.classList.remove('opening');

        items.forEach((item) => {
          item.style.transitionDelay = '0ms';
        });
      }
    });
  });
   document.addEventListener('DOMContentLoaded', function () {
    const menus = document.querySelectorAll('.mega-menu');

    menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      const content = menu.querySelector('.mega-menu__content');

      if (!summary || !content) return;

      summary.addEventListener('click', () => {
        const items = content.querySelectorAll('.menu-flavor');

        // Always reset
        content.classList.remove('opening');
        items.forEach(item => {
          item.style.transitionDelay = '0ms';
        });

        // Force a reflow to restart animation
        void content.offsetWidth;

        // Re-add animation class with stagger
        content.classList.add('opening');
        items.forEach((item, i) => {
          item.style.transitionDelay = `${i * 90}ms`;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
